export default "__VITE_PUBLIC_ASSET__faae6214__"